/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Urlaubsantrag } from '../models/Urlaubsantrag';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UrlaubsantragService {

    /**
     * Get all vacation requests of the logged-in user
     * Get all vacation requests of the logged-in user
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getMyUrlaubsantraegeUrlaubsantragGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/urlaubsantrag/',
        });
    }

    /**
     * Create a new vacation request
     * Create a new vacation request for the logged-in user
     * @param requestBody 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createUrlaubsantragUrlaubsantragPost(
requestBody: Urlaubsantrag,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/urlaubsantrag/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete a vacation request
     * @param id 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteUrlaubsantragUrlaubsantragDelete(
id: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/urlaubsantrag/',
            query: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get all pending vacation requests
     * Get all pending vacation requests (requires admin/approval privileges)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPendingUrlaubsantraegeUrlaubsantragDashboardPendingGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/urlaubsantrag/dashboard/pending',
        });
    }

    /**
     * Get all approved vacation requests
     * Get all approved vacation requests (requires admin/approval privileges)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getApprovedUrlaubsantraegeUrlaubsantragDashboardApprovedGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/urlaubsantrag/dashboard/approved',
        });
    }

    /**
     * Process a vacation request
     * Process a vacation request (approve or reject)
 *
 * - id: The ID of the vacation request
 * - status: Either "Genehmigt" or "Abgelehnt"
     * @param id 
     * @param status 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static bearbeiteUrlaubsantragUrlaubsantragDashboardBearbeitenPost(
id: number,
status: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/urlaubsantrag/dashboard/bearbeiten',
            query: {
                'id': id,
                'status': status,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get an overview of all vacation requests
     * Get an overview of all vacation requests in a time range with filtering options
 *
 * - timeInterval_start: Start date in format YYYY-MM-DD
 * - timeInterval_end: End date in format YYYY-MM-DD
 * - filter_department: Filter by department (optional)
 * - filter_user: Filter by user ID (optional)
 * - filter_status: Filter by status (optional)
     * @param timeIntervalStart 
     * @param timeIntervalEnd 
     * @param filterDepartment 
     * @param filterUser 
     * @param filterStatus 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getUrlaubsantragOverviewUrlaubsantragDashboardOverviewPost(
timeIntervalStart: string,
timeIntervalEnd: string,
filterDepartment?: string,
filterUser?: string,
filterStatus?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/urlaubsantrag/dashboard/overview',
            query: {
                'timeInterval_start': timeIntervalStart,
                'timeInterval_end': timeIntervalEnd,
                'filter_department': filterDepartment,
                'filter_user': filterUser,
                'filter_status': filterStatus,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Calculate Vacation Days
     * Preview working days for a potential vacation request
     * @param beginn 
     * @param ende 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static calculateVacationDaysUrlaubsantragCalculateDaysPost(
beginn: string,
ende: string,
): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/urlaubsantrag/calculate-days',
            query: {
                'beginn': beginn,
                'ende': ende,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reset vacation request notifications for the current user
     * Reset the vacation request notification counter for the current user
     * @returns any Successful Response
     * @throws ApiError
     */
    public static resetVacationNotificationsUrlaubsantragResetVacationNotificationsPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/urlaubsantrag/reset-vacation-notifications',
        });
    }

}
